import { createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 首页/赛事荣誉榜 > 队员列表
 */
import { defineComponent, toRefs } from "vue";
import ListItem from "@/components/pc/member-list/components/list-item.vue";
import ListItemPreview from "@/components/pc/member-list/components/list-item-preview.vue";
export default defineComponent({
  name: "PCMemberList",
  props: {
    teamData: {
      type: Array,
      required: false,
      default: () => []
    },
    type: {
      type: String,
      required: false,
      default: () => ""
    }
  },
  setup(props) {
    const {
      teamData
    } = toRefs(props);
    return () => {
      const level = teamData.value.length;
      const fromHome = () => {
        if (level === 5) {
          return _createVNode("div", {
            "class": "pc-information-list"
          }, [_createVNode("div", {
            "class": "flex-box"
          }, [teamData.value.slice(0, 3).map(item => {
            return _createVNode(ListItem, {
              "itemInfo": item
            }, null);
          })]), _createVNode("div", {
            "class": "flex-box"
          }, [teamData.value.slice(3, 5).map(item => {
            return _createVNode(ListItem, {
              "itemInfo": item
            }, null);
          })])]);
        } else if (level === 6) {
          return _createVNode("div", {
            "class": "pc-information-list"
          }, [_createVNode("div", {
            "class": "flex-box"
          }, [teamData.value.slice(0, 3).map(item => {
            return _createVNode(ListItem, {
              "itemInfo": item
            }, null);
          })]), _createVNode("div", {
            "class": "flex-box"
          }, [teamData.value.slice(3, 6).map(item => {
            return _createVNode(ListItem, {
              "itemInfo": item
            }, null);
          })])]);
        } else {
          return _createVNode("div", {
            "class": "pc-information-list"
          }, [_createVNode("div", {
            "class": "flex-box"
          }, [teamData.value.slice(0, 4).map(item => {
            return _createVNode(ListItem, {
              "itemInfo": item
            }, null);
          })]), _createVNode("div", {
            "class": "flex-box"
          }, [teamData.value.slice(4, 7).map(item => {
            return _createVNode(ListItem, {
              "itemInfo": item
            }, null);
          })])]);
        }
      };
      const fromPreview = () => {
        if (level === 5) {
          return _createVNode("div", {
            "class": "pc-information-list"
          }, [_createVNode("div", {
            "class": "flex-box-preview"
          }, [teamData.value.slice(0, 3).map(item => {
            return _createVNode(ListItemPreview, {
              "itemInfo": item
            }, null);
          })]), _createVNode("div", {
            "class": "flex-box-preview"
          }, [teamData.value.slice(3, 5).map(item => {
            return _createVNode(ListItemPreview, {
              "itemInfo": item
            }, null);
          })])]);
        } else if (level === 6) {
          return _createVNode("div", {
            "class": "pc-information-list"
          }, [_createVNode("div", {
            "class": "flex-box-preview"
          }, [teamData.value.slice(0, 3).map(item => {
            return _createVNode(ListItemPreview, {
              "itemInfo": item
            }, null);
          })]), _createVNode("div", {
            "class": "flex-box-preview"
          }, [teamData.value.slice(3, 6).map(item => {
            return _createVNode(ListItemPreview, {
              "itemInfo": item
            }, null);
          })])]);
        } else {
          return _createVNode("div", {
            "class": "pc-information-list"
          }, [_createVNode("div", {
            "class": "flex-box-preview"
          }, [teamData.value.slice(0, 4).map(item => {
            return _createVNode(ListItemPreview, {
              "itemInfo": item
            }, null);
          })]), _createVNode("div", {
            "class": "flex-box-preview"
          }, [teamData.value.slice(4, 7).map(item => {
            return _createVNode(ListItemPreview, {
              "itemInfo": item
            }, null);
          })])]);
        }
      };
      return _createVNode("div", null, [props.type == "弹窗" ? fromPreview() : fromHome()]);
    };
  }
});